import { I18N } from '@/app'
import { firebaseService, getFirebase } from '@/services/firebaseApp'
import { QueryKeys } from '@/services/api/session/queryKeys'

export function warnEmailInUse() {
  alert(I18N.t('emailInUseMsg'))
}

/**
 * Whether somebody is signed in with a profile this server knows.
 *
 * Both halves, deliberately: the query cache reports a profile from a warm cache, which
 * survives a sign-out for as long as the cache does, so the Firebase session remains the
 * thing that says the person is actually signed in.
 */
export function isLoggedIn() {
  return !!QueryKeys.me.getData()?.id && !!firebaseService.instance?.auth()?.currentUser?.uid
}

export function getProfile() {
  return QueryKeys.me.getData()
}

export async function reauthenticate(password: string) {
  const profile = QueryKeys.me.getData()

  if (!profile) return

  const firebase = await getFirebase()

  return firebase.auth().signInWithEmailAndPassword(profile.email, password)
}

export const toggleRememberMe = async (rememberMe: boolean) => {
  const firebase = await getFirebase()
  const persistence = rememberMe ? firebase.auth.Auth.Persistence.SESSION : firebase.auth.Auth.Persistence.NONE

  firebase.auth().setPersistence(persistence)
}
